export class CreditCardControl {
    flags = {
      AMEX: {
        id: 3,
        mask: "9999-999999-99999",
        name: "American Express",
        flag: "amex",
        regex: /^3[47]\d{13}$/
      },
      DINERS: {
        id: 4,
        mask: "9999-999999-99999",
        name: "Diners Club",
        flag: "diners",
        regex: /^3(?:0[0-5]|[68]\d)\d{11}$/
      },
      ELO: {
        id: 6,
        mask: "9999-9999-9999-9999",
        name: "Elo",
        flag: "elo",
        regex: /(4011|431274|438935|451416|457393|4576|457631|457632|504175|627780|636297|636368|636369|(6503[1-3])|(6500(3[5-9]|4[0-9]|5[0-1]))|(6504(0[5-9]|1[0-9]|2[0-9]|3[0-9]))|(650(48[5-9]|49[0-9]|50[0-9]|51[1-9]|52[0-9]|53[0-7]))|(6505(4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-8]))|(6507(0[0-9]|1[0-8]))|(6507(2[0-7]))|(650(90[1-9]|91[0-9]|920))|(6516(5[2-9]|6[0-9]|7[0-9]))|(6550(0[0-9]|1[1-9]))|(6550(2[1-9]|3[0-9]|4[0-9]|5[0-8]))|(506(699|77[0-8]|7[1-6][0-9]))|(509([0-9][0-9][0-9])))/
      },
      AURA: {
        id: 8,
        mask: "9999-9999-9999-9999",
        name: "Aura",
        flag: "aura",
        regex: /^50\d{14}/
      },
      HIPERCARD: {
        id: 5,
        mask: "9999-9999-9999-9999",
        name: "Hipercard",
        flag: "hipercard",
        regex: /^(606282\d{10}(\d{3})?)|(3841\d{15})$/
      },
      MASTERCARD: {
        id: 2,
        mask: "9999-9999-9999-9999",
        name: "Mastercard",
        flag: "master",
        regex: /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/
      },
      VISA: {
        id: 1,
        mask: "9999-9999-9999-9999",
        name: "Visa",
        flag: "visa",
        regex: /^4\d{12}(?:\d{3})?$/
      },
      DISCOVER: {
        id: 7,
        mask: "9999-9999-9999-9999",
        name: "Discover",
        flag: "discover",
        regex: /^(6011\d{12,15}|622\d{13,16}|64\d{14,17}|65\d{14,17})/
      },
      JCB: {
        id: 9,
        mask: "9999-9999-9999-9999",
        name: "JCB",
        flag: "jcb",
        regex: /^35\d{14,17}/
      }
    };

    constructor() {
      this.getCard = this.getCard.bind(this);
      this.getFlag = this.getFlag.bind(this);
    }

    getCard(value) {
      value = value.replace(/[^\d]/g, "");

      const _keys = Object.keys(this.flags);

      for (let k in _keys) {
        let _key = _keys[k],
            _item = this.flags[_key];

        if (_item.regex.test(value)) return _item;
      }

      return {
        id: 0,
        mask: "00000000000000000000000000000000000000000000000000",
        name: "None",
        flag: "none",
        regex: /(.*)/
      };
      /*

        for(let i in this.flags) {
            if(this.flags[i].regex.test(value)) {
                return this.flags[i];
            }
        }
      */
    }

    getFlag(value) {
      value = value.replace(/[^\d]/g, "");

      const _keys = Object.keys(this.flags);

      for (let k in _keys) {
        let _key = _keys[k],
            _item = this.flags[_key];

        if (_item.regex.test(value)) return _item.flag;
      }

      return "none";

      /*
        for(let i in this.flags) {
            if(this.flags[i].regex.test(value)) {
                return this.flags[i].flag;
            }
        }
      */
    }
}


// WEBPACK FOOTER //
// ./src/utils/CreditCardControl.js